import { render, staticRenderFns } from "./CmgHeroPromoBanner.vue?vue&type=template&id=7be3ae5a&scoped=true&lang=pug"
import script from "./cmg-hero-promo-banner.ts?vue&type=script&lang=ts&external"
export * from "./cmg-hero-promo-banner.ts?vue&type=script&lang=ts&external"
import style0 from "./CmgHeroPromoBanner.vue?vue&type=style&index=0&id=7be3ae5a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7be3ae5a",
  null
  
)

export default component.exports